// src/components/store/sections/faqs/FaqV71TwocolumnboxLimeZest.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV71TwocolumnboxLimeZest(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={71}
      archKey="two_column_box"
      archLabel="Two-Column Split Grid"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
